var showDebug = true;

require([
	'jquery'
], function(
	$
	) {

	'use strict';


	if ($('.section-cards').length) {

		var $rows = $('.row'),
			$cards = $('.card'),
			$cardsMore = $('.card--more');


		function scrollAnimation($element, extra) {
			var offset = $element.offset();
			offset.top -= extra;
			$('body, html').animate({
				scrollTop: offset.top
			}, 500 );
		}


		$('.js_read-more').click(function(e){
			e.preventDefault();
			e.stopPropagation();

			var $currentCard = $(this).parent(),
				$currentRow = $currentCard.parent(),
				$currentMore = $currentCard.next(),
				isActive = $currentCard.hasClass('is-active');

			$('.js_read-more').removeClass('is_active');
			$rows.removeClass('row--expanded');
			$cards.removeClass('is-active');
			$cardsMore.attr('aria-expanded', false);

			if (!isActive) {
				$(this).addClass('is_active');
				$currentRow.addClass('row--expanded');
				$currentCard.addClass('is-active');
				$currentMore.attr('aria-expanded', true);
				scrollAnimation($currentMore, 200);
			}
		});



		if ($('.card--marktpreise').length) {

			var currentWeek = parseInt($('.card__marktpreise-week').attr('data-week')),
				currentYear = parseInt($('.card__marktpreise-week').attr('data-year')),
				marktpreiseData = JSON.parse($('.card__marktpreise-week').attr('data-json')),
				$marktpreiseValues = $('.card__marktpreise-price__value');

			function updateMarktpreise(week) {
				$marktpreiseValues.each(function(){
					var category = $(this).attr('data-category');
					var newValue = parseFloat(marktpreiseData[week-1][category]);

					if (isNaN(newValue)) {
						$(this).addClass('no-data');
						$(this).text(marktpreiseData[week-1][category]);
					} else {
						$(this).removeClass('no-data');
						$(this).text(marktpreiseData[week-1][category].replace('.',','));
					}
				});
			}

			$('.js_card__load-week').click(function(){
				var action = $(this).attr('data-action'),
					active = $(this).attr('active'),
					$week = $('.card__marktpreise-week'),
					$weekText = $('.card__marktpreise-week__text'),
					week = parseInt($week.attr('data-week')),
					$next = $('.card__marktpreise-next'),
					$prev = $('.card__marktpreise-prev');

				if (action === 'prev') {
						$next.attr('active', '');
					if (week === 1) {
						$week.attr('data-week', currentWeek);
						$weekText.text(currentWeek);
						updateMarktpreise(currentWeek);
						$next.removeAttr('active');
					} else {
						$week.attr('data-week', week-1);
						$weekText.text((week-1));
						updateMarktpreise(week-1);
					}
				} else if (action === 'next' && week !== currentWeek) {
					$prev.attr('active', '');
					$week.attr('data-week', (week+1));
					$weekText.text(week+1);
					updateMarktpreise(week+1);

					if (week === currentWeek-1) {
						$(this).removeAttr('active');
					}
				}
			});
		}



	}
});
define("root/Assets/Templates/Html/Grid/Js/Grid", function(){});

